export default __webpack_public_path__ + "static/media/1631.8106a840.png";